import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";
import { defaultTheme } from "../../../../theme/theme";

export const Text = styled.div`
  font-weight: 600;
  font-size: 0.85em;
  position: relative;
  top: 3px;

  ${mediaMaxWidth.tablet`
    font-size: 0.7em;
    top: -6px;
  `}
`;

export const Icon = styled.div`
  font-size: 2.2em;
  position: relative;
  top: 1px;
  opacity: 1;
  animation: pulsateIcon 6s linear infinite;
  color: ${defaultTheme.colors.mainLinkColor};

  @keyframes pulsateIcon {
    0% {
      opacity: 1;
      color: ${defaultTheme.colors.mainLinkColor};
    }
    5% {
      opacity: 0.5;
      transform: scale(0.96);
    }
    10% {
      opacity: 1;
      color: ${defaultTheme.colors.mainPurpleColor};
      transform: scale(1);
    }
    15% {
      opacity: 0.5;
      transform: scale(0.96);
    }
    19% {
      color: ${defaultTheme.colors.mainLinkColor};
    }
    20% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 1;
    }
  }

  ${mediaMaxWidth.tablet`
    font-size: 1.2em;
    top: 8px;
  `}
`;

export const Wrapper = styled.button`
  margin: 0 19px;
  height: 54px;
  display: flex;
  border: none;
  color: ${defaultTheme.colors.mainLinkColor};
  width: 155px;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;

  &:hover {
    ${Text}, ${Icon} {
      color: ${defaultTheme.colors.mainPurpleColor};
      opacity: 1;
      animation: none;
    }
  }

  &:focus {
    outline: none;
  }

  ${mediaMaxWidth.tablet`
    margin: 0;
    flex-direction: column-reverse;
    width: 100px;
  `}

  ${mediaMaxWidth.phone`
    #refer-a-friend-tooltip {
      display: none !important;
    }
  `}
`;
